import bridge from './bridge.png'

const content = `<p>The Bridge pattern is useful when we have a concept with several implementations that uses another concept with several implementations. The Bridge pattern consists in separating them out into two hierarchies:</p>

<img src=${bridge} alt="bridge" />

<p>The client calls an implementation of <code>A</code> without knowing its exact type, and each of the implementations of <code>A</code> accesses an object that implements <code>B</code> without knowing its exact type.</p>

<p>By separating the two concepts in separate hierarchies, the Bridge pattern prevents them from being mixed in the same code and having the cartesian product of all the implementations. Bridge helps achieve <a href="/high-cohesion">High cohesion</a>.</p>`

export default content
